import { Box, Button, Flex, Icon, Spinner, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FiArrowLeft, FiDownload } from "react-icons/fi";
import { getCurrentDocuments, PlatformDocument } from "@lubbezposrednio-frontend/core";
import { DocumentHtml, DOC_TITLES, SLUG_TO_TYPE } from "./documentShared";

// Osadzony widok dokumentu (regulamin / polityka / deklaracja) — treść HTML renderowana natywnie.
export const DocumentView: React.FC<{ type?: string }> = ({ type: typeProp }) => {
  const { slug } = useParams<{ slug: string }>();
  const type = typeProp ?? (slug ? SLUG_TO_TYPE[slug] : undefined);
  const [doc, setDoc] = useState<PlatformDocument | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getCurrentDocuments()
      .then(r => {
        if (active) setDoc(r.data.documents.find(d => d.type === type) ?? null);
      })
      .catch(() => active && setDoc(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [type]);

  const title = (type && DOC_TITLES[type]) || "Dokument";

  return (
    <Box maxW="860px" mx="auto" px={{ base: "20px", md: "32px" }} py={{ base: "28px", md: "44px" }}>
      <Button as={Link} to="/" variant="ghost" size="sm" leftIcon={<FiArrowLeft />} color="primary" mb="18px" fontWeight="700">
        Strona główna
      </Button>

      <Box bg="white" borderRadius="20px" border="1px solid rgba(67,0,152,0.08)" boxShadow="0 8px 26px rgba(67,0,152,0.06)" p={{ base: "24px", md: "40px" }}>
        <Flex justify="space-between" align="flex-start" gap="14px" mb="18px" wrap="wrap">
          <Box>
            <Text fontSize={{ base: "24px", md: "30px" }} fontWeight="900" color="primary">{title}</Text>
            {doc && (
              <Text fontSize="13px" color="gray.400" mt="3px">
                Wersja {doc.version} · zaktualizowano {new Date(doc.updated_at).toLocaleDateString("pl-PL")}
              </Text>
            )}
          </Box>
          {doc?.file_url && (
            <Button as="a" href={doc.file_url} target="_blank" rel="noopener noreferrer" size="sm" variant="outline" borderColor="rgba(67,0,152,0.2)" color="primary" borderRadius="11px" fontWeight="700" leftIcon={<Icon as={FiDownload} />}>
              Pobierz PDF
            </Button>
          )}
        </Flex>

        {loading ? (
          <Flex justify="center" py="60px"><Spinner color="primary" /></Flex>
        ) : (
          <DocumentHtml html={doc?.content ?? null} />
        )}
      </Box>
    </Box>
  );
};

export default DocumentView;
